// Canonical DealShaq discount tiers — frontend mirror of the backend single
// source of truth (services/pricing_service.py DISCOUNT_TIERS). Keep these in
// sync. All retailer-facing tier labels import from here so they never drift.
//   drlp     = discount the grocer gives DealShaq (off regular price)
//   consumer = discount the shopper sees (off regular price)
export const DISCOUNT_TIERS = [
  { level: 1, name: 'Sizzling', fullName: 'Sizzling Deal', drlp: 60, consumer: 50 },
  { level: 2, name: 'Hot', fullName: 'Hot Deal', drlp: 75, consumer: 60 },
  { level: 3, name: 'Sizzling Hot', fullName: 'Sizzling Hot Deal', drlp: 90, consumer: 75 },
];

export const getTier = (level) =>
  DISCOUNT_TIERS.find((t) => t.level === Number(level)) || DISCOUNT_TIERS[0];
